<mat-form-field [attr.data-test-id]="testId"
                class="form-input">
  <mat-label>{{label}}</mat-label>
  <input [formControl]="formControl"
         [placeholder]="placeholder"
         [attr.aria-label]="label"
         [maxLength]="maxLength"
         type="text"
         class="input"
         autocomplete="off"
         InputTrim
         matInput>
  <mat-hint>не обов’язково</mat-hint>
  <mat-error>{{getError(addressNote, AddressNoteErrors)}}</mat-error>
</mat-form-field>
